<template>
	<datatable
		v-model:server-options="params"
		size="large"
		:total
		:rows="params.rowsPerPage"
		:headers
		:value="items"
		:loading
		clickable
		@row-click="handleRowClick">
	</datatable>
</template>

<script lang="ts" setup>
	import { watch } from 'vue'
	import { useRouter } from 'vue-router'
	import { useDatatable } from '@/composables/datatable.js'
	import type { Header, Row } from '@/data/types/datatable'

	const router = useRouter()
	const { params } = useDatatable()

	defineProps({
		items: {
			type: Array<Row>,
			default: []
		},
		total: {
			type: Number,
			default: 0
		},
		loading: {
			type: Boolean
		}
	})

	function handleRowClick(item: Row) {
		if (item && item.id) {
			router.push(`/yard-app/stock-item/${item.contract_number}`)
		}
	}

	const headers: Header[] = [
		{ value: 'contract_number', text: 'Contract Number', props: { sortable: true } },
		{ value: 'account', text: 'Account Name', props: { sortable: true } },
		{ value: 'delivery_date', text: 'Del Date', props: { sortable: true } }
	]

	const emit = defineEmits(['paramsChanged'])

	watch(
		params,
		() => {
			emit('paramsChanged', params.value)
		},
		{ deep: true }
	)
</script>
